

<template>
    <div class="Xvuefilter">
        <div class="form-group">
            <label id="filtertitle">{{filtertitle}}</label>
            <slot></slot> 
        </div>

    </div>
</template>

<script>
'use strict'
export default { 
        props: {            
            enabled: {
                type: Boolean,
                default: false
            },
            filtertitle: {
                type: String,
                default: ''
            }
        },
        data() {
        return {

            }
        },
        methods: {            
        }
}

</script>
